// Mock data for Ramspor AI IT Services Landing Page

export const trustMetrics = [
  {
    id: 1,
    value: "5+ Years",
    label: "Enterprise Experience"
  },
  {
    id: 2,
    value: "Fortune 500",
    label: "Companies Experience"
  },
  {
    id: 3,
    value: "Agile",
    label: "Offshore Delivery"
  },
  {
    id: 4,
    value: "Dedicated",
    label: "SAP Support Team"
  }
];

export const services = [
  {
    id: 1,
    title: "SAP Support",
    description: "Comprehensive support services to keep your SAP systems running smoothly",
    features: [
      "L1/L2/L3 Support",
      "Incident Management",
      "Ticket Resolution"
    ]
  },
  {
    id: 2,
    title: "SAP Testing",
    description: "Ensure quality and reliability with our expert SAP testing services",
    features: [
      "UAT Testing",
      "Regression Testing",
      "QA Coordination"
    ]
  },
  {
    id: 3,
    title: "SAP Business Analysis",
    description: "Expert business analysis to optimize your SAP processes",
    features: [
      "Requirement Gathering",
      "Process Mapping",
      "Stakeholder Management"
    ]
  },
  {
    id: 4,
    title: "SAP Integration Services",
    description: "Seamless integration solutions for your SAP ecosystem",
    features: [
      "API Integration Support",
      "Data Migration Support",
      "Middleware Coordination"
    ]
  }
];

export const benefits = [
  {
    id: 1,
    title: "Cost Effective Offshore Support",
    description: "Reduce operational costs with our efficient offshore model"
  },
  {
    id: 2,
    title: "Flexible Working Hours",
    description: "Round-the-clock support aligned with your business hours"
  },
  {
    id: 3,
    title: "Fast Response Time",
    description: "Quick turnaround on issues and support requests"
  },
  {
    id: 4,
    title: "Enterprise Experience",
    description: "Proven track record with global enterprise clients"
  },
  {
    id: 5,
    title: "Dedicated Team",
    description: "Committed professionals focused on your success"
  },
  {
    id: 6,
    title: "Scalable Support Model",
    description: "Flexible solutions that grow with your business needs"
  }
];

export const companyInfo = {
  name: "Ramsporia IT Services Private Limited",
  description: "Ramsporia IT Services Private Limited is an India-based SAP services company providing offshore SAP support, testing, business analysis, and integration services for global enterprises and growing businesses.",
  email: "rs@ramsporiaitservices.com",
  year: "2026"
};

export const sapModules = [
  {
    id: 1,
    code: "MM",
    name: "Materials Management",
    description: "End-to-end procurement, vendor management, purchase orders, goods receipt, and invoice verification.",
    capabilities: [
      "Procurement Process",
      "Vendor Master Data",
      "Purchase Requisitions",
      "Invoice Verification"
    ]
  },
  {
    id: 2,
    code: "WM",
    name: "Warehouse Management",
    description: "Warehouse operations, storage strategies, putaway, picking, and transfer order management.",
    capabilities: [
      "Storage Bin Management",
      "Putaway & Picking",
      "Transfer Orders",
      "RF Operations"
    ]
  },
  {
    id: 3,
    code: "IM",
    name: "Inventory Management",
    description: "Real-time stock control, goods movements, physical inventory, and cycle counting processes.",
    capabilities: [
      "Stock Overview",
      "Goods Movements",
      "Physical Inventory",
      "Batch Management"
    ]
  },
  {
    id: 4,
    code: "AP",
    name: "Accounts Payable",
    description: "Vendor invoice processing, payment runs, withholding tax, and accounts payable reconciliation.",
    capabilities: [
      "Invoice Processing",
      "Payment Runs (F110)",
      "Vendor Reconciliation",
      "Withholding Tax"
    ]
  }
];